export default "__VITE_ASSET__CclIIBnD__"